import React from 'react';
import GrowFollowers from "../../static/landing/landing-grow-followers.png";
import LikePosts from "../../static/landing/landing-like-posts.png";
import BulkMessaging from "../../static/landing/landing-bulk-messaging.png";
import AutoBump from "../../static/landing/landing-auto-relist.png";
import BoostReviews from "../../static/landing/landing-boost-reviews.png";

import "../../styles/LandingValueProps.css";

export default function LandingValueProps() {
    return (
        <div id="features" className="LandingValueProps">
            <section className="valueProp-section">
                <div className="bg bg-red"></div>
                <div className="valueProp section-left">
                    <img src={GrowFollowers} alt="Grow followers"/>
                    <div>
                        <h1>Organic, Targeted Follower Growth <span role="img" aria-label="rocketship">🚀</span></h1>
                        <p>Enter a seller you like and automatically follow all of their followers in one click. 
                        Gain thousands of new followers and automatically unfollow your following at any instant. 
                        Save a list of users you don’t want to unfollow and we’ll blacklist them!</p>
                    </div>
                </div>
            </section>
            <section className="valueProp-section">
                <div className="bg-blue-wrapper">
                    <div className="bg bg-blue"></div>
                </div>
                <div className="valueProp section-right">
                    <img src={LikePosts} alt="Like posts"/>
                    <div>
                        <h1>Liking Similar Items <span role="img" aria-label="hearts">💕</span></h1>
                        <p>Enter a user who sells similar clothing to yours and automatically like all of their listings. 
                        Doing this will increase engagement to your store and lead more buyers towards you!</p>
                    </div>
                </div>
            </section>
            <section className="valueProp-section">
                <div className="bg bg-red"></div>
                <div className="valueProp section-left">
                    <img src={BulkMessaging} alt="Bulk messaging"/>
                    <div>
                        <h1>Message Your Likers In Bulk <span role="img" aria-label="message">💬</span></h1>
                        <p>Getting a lot of likes on your items but not still not selling? This feature allows you to send 
                        messages to everyone who likes a specific post. Example: sending out a message offering likers a discount 
                        to encourage the sale!</p>
                    </div>
                </div>
            </section>
            <section className="valueProp-section">
                <div className="bg-blue-wrapper">
                    <div className="bg bg-blue"></div>
                </div>
                <div className="valueProp section-right">
                    <img src={AutoBump} alt=""/>
                    <div>
                        <h1>Automatically Bump Your Products <span role="img" aria-label="refresh">🔁</span></h1>
                        <p>Tired of manually relisting/refreshing your products to get them seen? Select how often you want all
                        of your listings to be bumped and we’ll automatically refresh them for you!</p>
                    </div>
                </div>
            </section>
            <section className="valueProp-section">
                <div className="bg bg-red"></div>
                <div className="valueProp section-left">
                    <img src={BoostReviews} alt=""/>
                    <div>
                        <h1>Improve Your Reviews <span role="img" aria-label="star">⭐</span></h1>
                        <p>Often times when you sell an item, the buyer will love it, but will forget to leave feedback. This feature 
                        allows you to automatically send a personalized review request message to buyers who haven’t left feedback after 
                        a custom time period.</p>
                    </div>
                </div>
            </section>
        </div>
        )};
